import { render, staticRenderFns } from "./rollver_page.vue?vue&type=template&id=c5de0e4c&scoped=true&"
import script from "./rollver_page.vue?vue&type=script&lang=js&"
export * from "./rollver_page.vue?vue&type=script&lang=js&"
import style0 from "./rollver_page.vue?vue&type=style&index=0&id=c5de0e4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5de0e4c",
  null
  
)

export default component.exports